import { render } from "./SideMenuComponent.vue?vue&type=template&id=cf476632&scoped=true"
import script from "./SideMenuComponent.vue?vue&type=script&lang=js"
export * from "./SideMenuComponent.vue?vue&type=script&lang=js"

import "./SideMenuComponent.vue?vue&type=style&index=0&id=cf476632&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cf476632"]])

export default __exports__